<template>
  <!-- 中转空壳：不渲染任何业务 UI，仅在 created 完成鉴权校验后重定向，保证"去使用"无感 -->
  <div class="console-transit"></div>
</template>

<script>
// NCNP "我的资源 → 去使用"中转组件。
//
// 链路：NCNP 点"去使用"(external_link_console=/console/transit) →
//   无本地 token：路由守卫(ncnpAuthEntry)走 NCNP 静默授权 → /ncnp/callback 换 token → 回本页；
//   有本地 token：本组件 created 校验 token 有效性 →
//     有效  → window.location.replace 到智算一站式 AI 平台 landing(token 由 buildAiLandingUrl 注入)；
//     过期  → gotoReLogin()，return_path 取当前 /console/transit，重新登录后回本页继续跳转。
//
// token 经本平台注入后，AI 平台服务端回查 /sso/getUserInfoByUserToken 落实 SSO，
// 三方用户（NCNP ↔ 本平台 ↔ AI 平台）经 platformUserAuth 映射保持统一。
import store from "@/store";
import { gotoReLogin } from "@/utils/ncnp";
import { buildAiLandingUrl } from "@/utils/ai-platform";

export default {
  name: "ConsoleTransit",
  async created() {
    try {
      // 守卫已保证到达本组件时 getToken() 存在；此处校验是否仍有效，避免带过期 token 跳过去被 AI 侧拒。
      const result = await store.dispatch("user/checkTokenValidity");
      if (result && result.isValid) {
        // 同标签页重定向（非 window.open），避免弹窗拦截与残留空白页
        window.location.replace(buildAiLandingUrl("aistudio"));
      } else {
        // gotoReLogin 无参 → currentReturnPath() 取当前 /console/transit 作为 return_path
        gotoReLogin();
      }
    } catch (e) {
      console.error("console_transit_failed", e);
      gotoReLogin();
    }
  },
};
</script>

<style scoped>
.console-transit {
  min-height: 100vh;
  background: transparent;
}
</style>
